module.exports = __webpack_public_path__ + "img/more_icon.43ba6620.svg";